module.exports = __webpack_public_path__ + "img/origin-3.deb925a8.png";